/**
 * Pakistani rupee.
 */
export var PKR = {
  code: 'PKR',
  base: 10,
  exponent: 2
};